<template>
  <modal
    title=" Product"
    width="35"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <div class="py-6">
      <div>
        <label class="label">Product Name:</label>
        <input
          type="text"
          class="input"
          placeholder="Enter"
          v-model="product.name"
        />
      </div>
      <div class="">
        <label class="label">Product Category:</label>
        <el-select v-model="product.category" placeholder="Select">
          <el-option
            v-for="sector in industrySectors"
            :key="sector"
            :label="sector"
            :value="sector"
          >
          </el-option>
        </el-select>
      </div>
      <div class="actions pt-4 flex justify-between">
        <div class="cursor-pointer" @click="closeModal">
          <p>Cancel</p>
        </div>
        <div>
          <primary-button
            buttonText="Save"
            :loading="loading"
            @click="submit"
          />
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    industrySectors: {
      required: false,
    },
    products: {
      required: false,
    },
    selectedProduct: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      product: {
        name: "",
        category: "",
      },
    };
  },
  watch: {
    showModal() {
      this.product = { ...this.selectedProduct };
    },
  },
  // mounted() {
  //   this.product = { ...this.selectedProduct };
  // },
  methods: {
    closeModal() {
      this.product = {
        name: "",
        category: "",
      };
      this.$emit("close-modal");
    },
    async submit() {
      this.loading = true;
      let payload = {};
      // Check if a product is being edited
      if (this.selectedProduct) {
        // Creates a copy of the original products array
        let updatedProducts = [...this.products];
        // Gets the index of the product we are updating
        let indexOfSelectedproduct = this.products.indexOf(
          this.selectedProduct
        );
        // Sets the updated values to the index of the selected product
        updatedProducts[indexOfSelectedproduct] = this.product;
        payload = {
          payload: {
            setting: {
              industrySector: [...this.industrySectors],
              products: [...updatedProducts],
            },
          },
        };
      } else {
        payload = {
          payload: {
            setting: {
              industrySector: [...this.industrySectors],
              products: [...this.products, this.product],
            },
          },
        };
      }

      try {
        const response = await this.$_updateIndustryAndProductSettings(payload);
        this.logResponse(response);
        this.generateToast("Success!", "success");
        this.$emit("created");
        this.closeModal();
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
